import type { QConfigStatus } from '@exam-management/graphql';
import { type LabelProps, Label } from '@shared/components';

import { QCONFIG_STATUS_COLOR, QCONFIG_STATUS_TEXT } from './constants';

export interface QConfigStatusTagProps extends LabelProps {
  status: QConfigStatus;
}

export default function QConfigStatusTag(props: Readonly<QConfigStatusTagProps>) {
  const { status, ...restProps } = props;

  return (
    <Label color={QCONFIG_STATUS_COLOR[status]} variant='outlined' size='large' {...restProps}>
      {QCONFIG_STATUS_TEXT[status]}
    </Label>
  );
}
